export const PRODUCTS = "/products"
export const PRODUCT_CATEGORIES = "/product-categories"
export const PRODUCT_BY_NAME = "/products/name"
export const CURRENT_USER = "/users/current-"
export const AUTHENTICATED_USER = "/users/authenticated"
export const USER_ROLE = "/users/role"
export const USERS = "/users"
export const CREATE_ADMIN = "/users/create-admin"
export const GUESTS = "/users/guests"
export const SHIPPING_DATA = "/shipping"
export const USER_TOKEN = "/auth/user-token"
export const LOGIN = "/auth/login"
export const LOGOUT = "/auth/logout"
export const ORDERS_BY_USER = "/orders/user"
export const ORDER_ITEMS = "/orders/items"
export const LAST_ORDER = "/orders/last-order"
